import { store } from '@src/state/store';
import { getCurrentGame } from '@src/state/selectors/selector_game';
import { pushEventQueue } from '@src/state/slices/slice_game';

import { Game } from '@src/lib/types';

export default () => (data: any) => {
  if (!data || !data.gameId) return;

  const game: Game | null = getCurrentGame(store.getState());
  if (game === null) throw new Error('[_drawTwo] game not found in root state');

  if (data.gameId == game.gameId) {
    console.log('DRAW TWO');
    store.dispatch(
      pushEventQueue({ message: 'DRAW TWO', showToast: true, sound: 'action' }),
    );
  }
};
